import styled, { css } from "styled-components";

export const FormContainer = styled.form`
  label {
    text-transform: initial;
  }
`;

export const Header = styled.h2`
  margin: 0;
  font-size: 18px;
  line-height: 22px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  text-transform: capitalize;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-color: #CBD5E1;

  .ant-modal-content {
    border-radius: 8px;
  }
`;

export const ButtonContainer = styled.div`
  width: fit-content;
  margin-left: auto;
  display: flex;
  gap: 1rem;

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 18.86px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
`;
